export default "__VITE_ASSET__Dc6guPxx__"